// AddEntryModal.js
import React, { useEffect, useState } from "react";
import CustomButton from "../../theme/style-components/CustomButton";
import {
  usePostDepartmentMutation,
  usePutDepartmentMutation,
} from "../../store/departments/DepartmentsApiSlice";
import {
  usePostTeamMutation,
  usePutTeamMutation,
} from "../../store/teams/TeamsApiSlice";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { selectCurrentUserObject } from "../../store/auth/authSlice";

const AddEntryModal = ({
  onClose,
  title,
  refetchData,
  selectedDepartment,
  setSelectedDepartment,
}) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [postDepartment] = usePostDepartmentMutation();
  const [postTeam] = usePostTeamMutation();
  const [putDepartment] = usePutDepartmentMutation();
  const [putTeam] = usePutTeamMutation();
  const user = useSelector(selectCurrentUserObject);

  useEffect(() => {
    if (selectedDepartment) {
      setName(selectedDepartment.name);
      setDescription(selectedDepartment.description);
    }
  }, [selectedDepartment]);

  const handleAdd = async () => {
    if (!name.trim() || !description.trim()) {
      alert("Please enter both name and description.");
      return;
    }
    if (title === "Department") {
      try {
        const result = await postDepartment({ name, description, org_id: user?.company })
          .unwrap()
          .then((res) => {
            console.log(res, "res");
            toast.success("Department added successfully");
            // Reset and close modal
            setName("");
            setDescription("");
            refetchData();
            onClose();
          });
      } catch (error) {
        toast.error(`Something went wrong!!`);
      }
    } else {
      try {
        const result = await postTeam({ name, description, org_id: user?.company })
          .unwrap()
          .then((res) => {
            console.log(res, "res");
            toast.success("Team added successfully");
            // Reset and close modal
            setName("");
            setDescription("");
            refetchData();
            onClose();
          });
      } catch (error) {
        toast.error(`Something went wrong!!`);
      }
    }
  };

  const handleEdit = async () => {
    if (!name.trim() || !description.trim()) {
      alert("Please enter both name and description.");
      return;
    }
    if (title === "Department") {
      console.log("Adding to departments...");
      try {
        const result = await putDepartment({
          name,
          description,
          org_id: user?.company,
          department_id: selectedDepartment.id,
        })
          .unwrap()
          .then((res) => {
            console.log(res, "res");
            toast.success("Department updated successfully");
            // Reset and close modal
            setName("");
            setDescription("");
            refetchData();
            onClose();
          });
      } catch (error) {
        toast.error(`Something went wrong!!`);
      }
    } else {
      console.log("Adding to teams...");
      try {
        const result = await putTeam({
          name,
          description,
          org_id: user?.company,
          team_id: selectedDepartment.id,
        })
          .unwrap()
          .then((res) => {
            console.log(res, "res");
            toast.success("Team updated successfully");
            // Reset and close modal
            setName("");
            setDescription("");
            refetchData();
            onClose();
          });
      } catch (error) {
        toast.error(`Something went wrong!!`);
      }
    }
  };

  return (
    <>
      <input
        type="text"
        name="name"
        placeholder="Enter name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
      />
      <input
        type="text"
        name="description"
        placeholder="Enter description"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
      />
      <CustomButton
        type="button"
        color="primary"
        buttonName={`${selectedDepartment?.id ? "Edit" : "Add"}`}
        onClick={() => {
          if (selectedDepartment) {
            handleEdit();
          } else {
            handleAdd();
          }
        }}
      />
    </>
  );
};

export default AddEntryModal;
